import Vue from 'vue'
import App from './App.vue'
//import Echo from "laravel-echo"
//import Pusher from 'pusher-js'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';

//axios
import axios from "./axios.js"
Vue.prototype.$http = axios;

// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuesax Admin Filters
import './filters/filters'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Feather font icon
require('./assets/css/iconfont.css')
/*
window.Echo = new Echo({
    authEndpoint : 'http://ccmt.local/broadcasting/auth',
    auth: {
        headers: {
            'x-session': this.auth.token
        }
    },
    broadcaster: 'pusher',
    key: 'ae2c6ab1f742f88a9914',
    cluster: 'mt1',
    encrypted: true
});
*/


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
